import React from "react";
import RouterMain from "./Router";

export default function App() {
  return (
    <>
      <RouterMain />
    </>
  )
}